import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import {Link, Outlet, useNavigate, useSearchParams} from "react-router-dom";
import {Breadcrumb, Button, Col, Collapse, Dropdown, Form, Menu, Row, Select, Space, Table, Tag} from "antd";
import {
    EyeInvisibleOutlined,
    EyeOutlined,
    FilterOutlined,
    MoreOutlined,
    PlusCircleOutlined,
    ReloadOutlined,
    SearchOutlined
} from "@ant-design/icons";
import {isNull} from "../../../tech/check_string";
import ModalWindow from "../../../modal";
import DB_Branch from "../../../../database/dictionary/branch";
import DB_PayForms from "../../../../database/dictionary/pay-forms";
import NextButton from "../../../tech/next_button";

const PayForms = () => {
    const {t} = useTranslation()
    const {token, defaultPageSize, setToken} = useContext(Context)

    const navigate = useNavigate()
    const p = new URLSearchParams(window.location.search)
    const {getActiveBranches} = DB_Branch(token)
    const {getPayForms, changeStatusPayForm} = DB_PayForms(token)
    const controller = new AbortController()

    const [form] = Form.useForm();
    const [searchParams, setSearchParams] = useSearchParams({})
    const [search, setSearch] = useState({})
    const [countFilters, setCountFilters] = useState(0)
    const {errorConnect} = ModalWindow()


    const [data, setData] = useState([])
    const [wait, setWait] = useState(false)
    const [branch, setBranch] = useState([])

    const [pagination, setPagination] = useState({
        //current: 1,
        pageSize: defaultPageSize,
        //total:200,
        showSizeChanger: false
    });

    const paginatorChange = (pagination, filters, sorter) => {
        if (pagination.current === 1) {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                page: pagination.current
            }))
        }

        if (pagination.pageSize === defaultPageSize) {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                size: pagination.pageSize
            }))
        }
        window.scrollTo(0, 0)
    };

    const changeStatus = (id) => {
        setWait(true)
        changeStatusPayForm(id)
            .then(res => {
                if (res.status === 200) {
                    const newData = data.map(n => {
                        if (n.id === id) {
                            return {...n, status: n.status === 0 ? 1 : 0}
                        }
                        return n
                    })
                    setData(newData)
                }
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
            .finally(() => {
                setWait(false)
            })
    }

    // const deleteRow = (id) => {
    //     setWait(true)
    //     deletePayForm(id)
    //         .then(res => {
    //             if (res.status === 204) {
    //                 navigate('/404', {replace: true})
    //             }
    //             if (res.status === 200) {
    //                 const newData = data.filter((item) => item.id !== id);
    //                 setData(newData);
    //             }
    //         })
    //         .catch(e => {
    //             if (e.request.status === 401) {
    //                 setToken(null)
    //             } else {
    //                 errorConnect()
    //             }
    //         })
    //         .finally(() => {
    //             setWait(false)
    //         })
    // }

    const clearFilter = () => {
        form.setFieldsValue({
                branch: null
            }
        )
        setSearch(current => {
            const {branch, ...rest} = current
            return rest
        })
    }

    const setFilter = () => {

        if (isNull(form.getFieldValue('branch'))) {
            setSearch(current => {
                const {branch, ...rest} = current
                return rest
            })
        } else {
            setSearch(prevState => ({
                ...prevState,
                branch: form.getFieldValue('branch')
            }))
            setCountFilters(countFilters + 1)
        }

        setSearch(current => {
            const {page, ...rest} = current
            return rest
        })
    }

    const Filters = () => {
        return (
            <>
                <Form
                    form={form}
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    layout={"vertical"}
                    style={{marginTop: '-10pt'}}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setFilter()
                        }
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name='branch'
                                label={t('branch')}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="name"
                                    optionLabelProp="name"
                                    allowClear>
                                    {branch.map(b =>
                                        <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Space
                    style={{marginTop: '-10pt', marginBottom: '20pt', width: '100%', justifyContent: 'flex-end'}}>
                    <Button icon={<ReloadOutlined/>} onClick={clearFilter}>{t('clear')}</Button>
                    <Button type={"primary"} icon={<SearchOutlined/>}
                            onClick={setFilter}>{t('search')}</Button>
                </Space>

            </>
        )
    }

    const getData = (page, size) => {
        if (wait) {
            controller.abort()
        }
        setWait(true)
        getPayForms(controller, page, size, searchParams)
            .then(res => {
                setData(res.data.data);
                setPagination({
                    ...pagination,
                    current: res.data.page,
                    total: res.data.count,
                    pageSize: res.data.size
                })
                setWait(false);
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });

    }

    useEffect(() => {
        window.scroll(0, 0)
        if (p.get("page") > 1) {
            setSearch(prevState => ({
                ...prevState,
                page: p.get("page")
            }))
        } else {
            setSearch(current => {
                const {p, ...rest} = current
                return rest
            })
        }

        if (p.has('branch')) {
            setSearch(prevState => ({
                ...prevState,
                branch: p.get("branch")
            }))
            form.setFieldsValue({
                    branch: parseInt(p.get("branch"))
                }
            )
        }

    }, [])

    useEffect(() => {
        setSearchParams(search)
        countButtonFilters()
    }, [search])

    useEffect(() => {
        getData(p.get("page"), defaultPageSize)
    }, [searchParams])

    const countButtonFilters = () => {
        let cnt = 0

        if (search.branch !== undefined) {
            cnt += 1
        }

        if (cnt === 0) {
            setCountFilters()
        } else {
            setCountFilters(cnt)
        }
    }

    useEffect(() => {
        getActiveBranches()
            .then(res => setBranch(res.data))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }, [])


    const columns = [
        {
            title: "ID",
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('name'),
            dataIndex: 'name',
            // render: (name, record) => <Link to={`${record.id}`} state={{path: searchParams.toString()}}>{name}</Link>
        },
        {
            title: t('grace_days'),
            dataIndex: 'grace_days',
        },
        {
            title: t('branch'),
            dataIndex: 'branch_id',
        },
        {
            title: t('status'),
            dataIndex: 'status',
            filters: [
                {
                    text: t('active'),
                    value: 1
                },
                {
                    text: t('disable'),
                    value: 0
                }
            ],
            onFilter: (value, record) => {
                return record.status === value
            },
            render: (status) => (
                <>
                    <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                        {status === 1 ? t('active') : t('disable')}
                    </Tag>
                </>
            ),
        },
        {
            title: '',
            render: (_, record) => (
                <>
                    <Dropdown overlay={menu(record)}>
                        <Button icon={<MoreOutlined />} type={"text"}/>
                    </Dropdown>
                </>
            ),
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={`${record.id}`} state={{path: searchParams.toString()}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ]

    const menu = (record) => (
        <Menu
            items={[
                {
                    label: (  <Button type={'text'} icon={record.status ? <EyeInvisibleOutlined/> :
                        <EyeOutlined/>} onClick={() => changeStatus(record.id)}>{t('change_status')}</Button>),
                    key: '2',
                },
                // {
                //     label: ( <Popconfirm title={t('q_sure_delete')} onConfirm={() => deleteRow(record.id)}>
                //         <Button danger type={'text'} icon={<DeleteOutlined/>}>{t('delete')}</Button>
                //     </Popconfirm>),
                //     key: '3',
                // },
            ]}
        />
    );



    return (
        <div>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('pay_forms')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <Link key='1' to="new" state={{id: null}}>
                            <Button type={'primary'} shape={'round'} icon={<PlusCircleOutlined/>}>{t('add')}</Button>
                        </Link>
                    </Space>
                </Space>

                <Collapse ghost expandIconPosition={'right'}>
                    <Collapse.Panel header={
                        <Space style={{
                            display: 'flex',
                            alignItems: 'end',
                            flexDirection: 'column',
                            flex:'auto'
                        }}>
                            <Button type={'text'} icon={<FilterOutlined/>}> {countFilters}</Button>
                        </Space>
                    }
                                    key="1"
                    >
                        <Filters/>
                    </Collapse.Panel>
                </Collapse>

                <Table
                    style={{'--cursor': "auto" }}
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    loading={wait}
                    pagination={pagination}
                    onChange={paginatorChange}
                    size={"small"}

                />


            </div>
            <Outlet/>
        </div>
    )
}

export default PayForms;